type CSSValue = string | number | boolean | null;

const cssVariables = (parameters: Record<string, CSSValue>): string => {
	return Object.entries(parameters)
		.map(([key, value]) => {
			// Handle values that are null, undefined
			if (value === null || value === undefined) {
				return '';
			}

			// Convert the value to a string (no unit addition)
			const valueString = String(value);

			return `${key}: ${valueString};`;
		})
		.filter(Boolean) // Remove any empty strings that might occur from invalid values
		.join('\n');
};

export default cssVariables;
